/**
 * Gets the Shopify product variant data for a given SKU.
 *
 * If a price override is defined for a tag which is assigned to the currently logged
 * in customer, this will be used instead of the base price.
 *
 * @param sku - The product SKU to look up
 * @param backendData - The backend data containing Shopify product variants
 * @returns The product variant if found, or undefined
 *
 * @example
 * ```typescript
 * const variant = getProductVariant('WRS119316-032-MTR', ctx.backendData)
 * if (variant) {
 *   console.log(`Price: ${variant.price}`)
 * }
 * ```
 */ export function getProductVariant(sku, backendData) {
    const baseProductVariant = backendData?.productVariants?.[sku];
    if (!baseProductVariant) {
        return undefined;
    }
    if (baseProductVariant.customerTagPriceOverride) {
        return {
            ...baseProductVariant,
            price: baseProductVariant.customerTagPriceOverride
        };
    }
    return baseProductVariant;
}

//# sourceMappingURL=pricing.js.map